const prisonerVerification = [
  {
    path: '/prisoner-verification-records',
    name: 'prisoner-verification-records',
    component: () => import('@/views/prisoner-verification/PrisonerVerificationRecords.vue'),
    meta: {
      protected: true,
      pageTitle: 'Prisoner Verification Records',
      breadcrumb: [
        { text: 'Prisoner Verification', active: true },
      ],
      navLink: true,
    },
  },
];

export default prisonerVerification;